export const getCurrencySymbol = (currencyCode: string) => {
  try {
    return new Intl.NumberFormat("en", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol",
    })
      .format(1)
      .replace(/\d/g, "")
      .trim();
  } catch {
    return currencyCode;
  }
};
